import Text from '@shared/components/content/text';
import GuideTemplate from '@shared/components/guide-template';
import { generatePath, useNavigate } from 'react-router-dom';
import distributionFlowDiagram from '../assets/distribution-diagram.png';
import { ccfRoutes } from '@app/ccf/ccf-routes';
import { useCCF } from '../../ccf-context';

export default function DistributionFlowIntroPage() {
  const navigate = useNavigate();
  const { uuid: reportUuid } = useCCF();

  return (
    <GuideTemplate
      preTitle="ADD DISTRIBUTION FLOW"
      title="Distribution flows"
      description={
        <Text>
          A flow is a single distribution path that your products take to get to
          the end consumer. Our flow creator helps you quickly model your
          distribution emissions to a sufficient level of accuracy for your
          Company Carbon Footprint report.
        </Text>
      }
      primaryActionText="Get started"
      primaryActionProps={{
        onClick: () =>
          navigate(
            generatePath(ccfRoutes.DISTRIBUTION_FLOW_ABOUT_CLIENTS, {
              report_uuid: reportUuid,
              flow_uuid: '',
            })
          ),
      }}
    >
      <div className="my-8 flex justify-center">
        <img
          src={distributionFlowDiagram}
          alt="Distribution flow diagram"
          className="h-auto max-w-full"
          style={{ minWidth: 300, maxWidth: 500 }}
        />
      </div>
    </GuideTemplate>
  );
}
